import React from 'react';
import { Box, Skeleton, Stack } from '@mui/material';

export interface MetricSkeletonProps {
    showIcon?: boolean;
    showChangeRow?: boolean;
}

const MetricSkeleton: React.FC<MetricSkeletonProps> = ({
    showIcon = false,
    showChangeRow = true,
}) => {
    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1.5,
                p: 1.5,
                borderRadius: 2,
                bgcolor: 'action.hover',
                minWidth: 200,
            }}
        >
            {showIcon && (
                <Skeleton animation="wave" variant="circular" width={48} height={48} sx={{ flexShrink: 0 }} />
            )}
            <Box sx={{ flex: 1, minWidth: 0 }}>
                <Skeleton animation="wave" variant="rounded" width={120} height={26} />
                <Skeleton animation="wave" variant="text" width="92%" sx={{ mt: 0.5 }} />
                <Skeleton animation="wave" variant="text" width="64%" sx={{ mt: 0.25 }} />
                {showChangeRow && (
                    <Stack direction="row" spacing={1} sx={{ alignItems: 'center', mt: 0.5 }}>
                        <Skeleton animation="wave" variant="rounded" width={76} height={22} />
                        <Skeleton animation="wave" variant="text" width={96} />
                    </Stack>
                )}
            </Box>
        </Box>
    );
};

export default MetricSkeleton;
